/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { PraticaOperatoreListItemDTO } from './pratica-operatore-list-item-dto';


export interface PagedModelPraticaOperatoreListItemDTO { 
    content?: Array<PraticaOperatoreListItemDTO>;
    page?: PageMetadata;
}

